import Presentation from "./presentation";

const component =  ( { open, handleClose } ) => {
	return (
		<Presentation
			handleClose = { handleClose }
			open        = { open }
		/>

	);
};

export default component;
